import { createContext } from 'react';
import { getComponents } from '../components/index.js';
var ApiContext = /*#__PURE__*/createContext({
  dialogId: null,
  leadId: null,
  data: null,
  isLoading: false,
  error: false,
  config: {},
  // Used for extended wizard only
  redirectUrl: null,
  setRedirectUrl: function setRedirectUrl() {}
});
var WizardContext = /*#__PURE__*/createContext({
  components: getComponents({}),
  dialogId: null,
  leadId: null,
  recruiterId: null,
  position: 'default',
  currentLine: null,
  currentStep: null,
  userData: {},
  stepData: {},
  setCurrentLine: function setCurrentLine() {},
  setCurrentStep: function setCurrentStep() {},
  setUserData: function setUserData() {},
  setStepData: function setStepData() {}
});
export { ApiContext, WizardContext };